<template>
  <el-dialog class="claim-dialog" v-on="$listeners" v-bind="$attrs" width="500px">
    <!-- 对话框头部 -->
    <div class="dialog-header" slot="title">
      <span class="dialog-title">商家认领</span>
      <span class="dialog-title__tip">商家信息的所有者或管理员可以看到我的个人信息</span>
    </div>

    <el-form :model="form" label-width="85px" ref="form">
      <el-form-item label="您的姓名">
        <el-input class="dialog-input" v-model="form.contactName" clearable></el-input>
      </el-form-item>
      <el-form-item label="您的电话">
        <YorkbbsPhoneInput
          class="dialog-input"
          v-model="form.contactNumber"
          clearable
          placeholder="000 000 0000"
        ></YorkbbsPhoneInput>
      </el-form-item>
      <el-form-item label="认领说明">
        <el-input
          type="textarea"
          :rows="3"
          placeholder="请输入认领说明"
          resize="none"
          v-model="form.claimReason"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button plain @click="$emit('update:visible', false)">取消</el-button>
        <el-button type="primary" @click="addClaim" :loading="loading">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import YorkbbsPhoneInput from '@/common/input-phone.vue';
export default {
  name: 'DialogClaim',
  components: { YorkbbsPhoneInput },
  props: {
    id: {
      required: true,
    },
  },
  data() {
    return {
      form: {
        contactName: '',
        contactNumber: '',
        claimReason: '',
      },
      loading: false,
    };
  },
  methods: {
    // 认领
    async addClaim() {
      if (!this.form.contactName) return this.$warning('请填写您的姓名');
      if (!/\d{9,11}/.test(this.form.contactNumber)) return this.$warning('电话格式不正确');
      if (!this.form.claimReason) return this.$warning('请输入认领说明');

      this.loading = true;
      await this.$axios
        .post('/info/v1/add/claim/rec', {
          postId: this.id,
          ...this.form,
        })
        .finally(() => {
          this.loading = false;
        });

      this.$success('提交成功');
      this.$emit('update:visible', false);
      this.$emit('submited');

      this.form = this.$options.data().form;
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-header {
  line-height: 28px;
}
.dialog-title {
  font-size: 20px;
  font-weight: 500;
}
.dialog-title__tip {
  font-size: 12px;
  color: var(--text-color-3);
  margin-left: 10px;
}
.dialog-input {
  width: 270px;
}

.button-cancel {
  font-size: 16px;
  color: var(--text-color-9);
}
.button-submit {
  line-height: 40px;
  padding: 0 34px;
  font-size: 16px;
  color: #fff;
  background-color: #027bf9;
  border-radius: 4px;
  border: 0 none;
}

.claim-dialog {
  ::v-deep {
    .el-dialog {
      border-radius: 10px;
    }
    .el-dialog__header {
      padding: 24px 30px;
    }
    .el-dialog__body {
      padding: 6px 30px 30px;
    }
    .el-form-item__label {
      font-size: 16px;
      color: var(--text-color);
    }
    .el-form-item {
      &:last-child {
        margin-bottom: 0;
        text-align: right;
      }
    }
    .el-button + .el-button {
      margin-left: 20px;
    }

    .el-button {
      &.el-button--text {
        color: var(--text-color-3);
      }
    }
  }
}
</style>
